// Route style configuration matching the RouteStyleDialog options
export interface RouteStyleConfig {
  color: string;
  borderColor: string;
  dasharray?: number[];
}

export const ROUTE_STYLES: Record<string, RouteStyleConfig> = {
  route: {
    color: '#DB2B35', // Red line
    borderColor: '#541115', // Dark red border
  },
  alt: {
    color: '#00FFFF', // Cyan line
    borderColor: '#11544A', // Dark cyan border
  },
  spur: {
    color: '#FF00FF', // Magenta line
    borderColor: '#54113D', // Dark magenta border
  },
  transport: {
    color: '#DB2B35', // Red line
    borderColor: '#541115', // Dark red border
    dasharray: [2, 2], // Dashed pattern
  },
};

// Default style if none is specified
export const DEFAULT_ROUTE_STYLE = 'route';